module.exports = __webpack_public_path__ + "media/post-listing-block-2-image@2x.b14b0940.webp";